import React from 'react';
import AdsDashboardHome from './adsDashboardHome';

const AdsDashboard: React.FC = () => {
	return <AdsDashboardHome />;
};

export default AdsDashboard;
